import styled from "styled-components";
import {colorPrimary, colorSecondary, hex2rgba } from "../../colors";
import { BreakPoints, ContentWidths } from "../../constants";

export const StyledTestimonialsWithCTA = styled.section.attrs({
  className: "testimonials-with-cta__container"
})`
  display: flex;
  width: 100%;
  color: ${colorSecondary};
  font-family: Rubik;
  justify-content: center;

  .testimonials-with-cta {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 15px;

    @media (min-width: ${BreakPoints.sm}) {
      width: ${ContentWidths.sm};
    }

    @media (min-width: ${BreakPoints.md}) {
      margin: 0px;
      width: ${ContentWidths.md};
    }

    @media (min-width: ${BreakPoints.lg}) {
      width: ${ContentWidths.lg};
    }

    @media (min-width: ${BreakPoints.xl}) {
      width: ${ContentWidths.xl};
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
    }
  }

  .testimonials {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;

    @media (min-width: ${BreakPoints.lg}) {
      width: 720px;
    }

    .t-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid #ccc;
      border-radius: 15px;
      padding: 30px;
      margin-bottom: 30px;
      box-shadow: 4px 4px 10px 0px ${hex2rgba("#000000", 0.25)};

      @media (min-width: ${BreakPoints.md}) {
        align-items: flex-start;
      }

      &--inactive {
        display: none;
      }

      &__top {
        display: flex;
        flex-direction: column;
        align-items: center;

        @media (min-width: ${BreakPoints.md}) {
          flex-direction: row;
          padding-bottom: 12px;
        }
      }

      &__logo {
        width: 100px;
        height: 100px;
      }

      &__header {
        display: flex;
        flex-direction: column;
        align-items: center;

        @media (min-width: ${BreakPoints.md}) {
          align-items: flex-start;
          padding-left: 16px;
        }
      }

      &__name {
        font-size: 1.3rem;
        font-weight: 700;
        padding: 8px 0;
        margin: 0 0 8px 0;

        @media (min-width: ${BreakPoints.md}) {
          margin: 0;
        }
      }

      &__title {
        font-size: 1.3rem;
        font-weight: 500;
        line-height: 1.1rem;
        text-align: center;
        margin: 0;
      }

      &__text {
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.1875rem;
        letter-spacing: 0.04em;
        margin: 0;

        @media (min-width: ${BreakPoints.md}) {
          font-size: 1.125rem;
        }
      }

      &__date {
        font-weight: bold;
        margin: 0;
        opacity: 50%;
        font-size: 0.875rem;
        align-self: flex-end;
      }
    }

    .t-controls {
      display: flex;
      align-items: center;

      &__left,
      &__right {
        color: ${hex2rgba(colorSecondary, 0.3)};
        font-size: 1.5rem;
        background: none;
        border: none;
      }

      &__dot {
        background: none;
        width: 18px;
        height: 18px;
        border: 2px solid ${hex2rgba(colorSecondary, 0.3)};
        border-radius: 50%;
        box-shadow: 1px 1px 4px 0 ${hex2rgba("#000000", 0.1)};
        margin: 0 5px;

        &--active {
          background-color: ${colorSecondary};
        }
      }

    }
  }

  .cta {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${colorPrimary};
    padding: 48px;
    text-align: center;

    @media (min-width: ${BreakPoints.sm}) {
      width: ${ContentWidths.sm};
    }

    @media (min-width: ${BreakPoints.md}) {
      width: ${ContentWidths.md};
    }

    @media (min-width: ${BreakPoints.lg}) {
      width: ${ContentWidths.lg};
    }

    @media (min-width: ${BreakPoints.xl}) {
      width: 350px;
      padding: 32px;
      margin-left: 32px;
    }

    &__title {
      font-family: Kapra Neue Pro;
      text-transform: uppercase;
      font-size: 2.1875rem;
      font-weight: normal;
      margin: 0 0 40px 0;

      @media (min-width: ${BreakPoints.xl}) {
        font-size: 1.75rem;
        margin-bottom: 14px;
      }
    }

    &__description {
      display: none;

      @media (min-width: ${BreakPoints.xl}) {
        display: block;
        font-size: 0.875rem;
        margin: 0 0 32px 0;
        letter-spacing: 0.025em;
      }
    }

    &__button {
      border: none;
      background-color: ${colorSecondary};
      font-family: Pitch Sans Bold;
      font-size: 1.125rem;
      padding: 14px 32px;
      text-decoration: none;
      color: ${colorPrimary};
    }
  }
`